import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-input" }

import AreaPicker from "./area-picker/area-picker.vue";
import { ElInput, ElButton, ElForm, ElFormItem } from "element-plus"
import { ref } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'search-input',
  emits: ['search', 'reset'],
  setup(__props, { emit: __emit }) {

const areaPicker = ref();
const emit = __emit
// 搜索框校验
const validateSearchPass = (rule, value, callback) => {
  if (value && value.length === 1) {
    callback(new Error('至少输入两个字进行搜索'));
  }
  callback()
}
const formData = ref({
  city: '',
  search: ''
})
const rulesForm = ref({
  search: [
    { validator: validateSearchPass, trigger: ['blur', 'change'] }
  ]
})

const onPositionConfirm = (val) => {
  formData.value.city = val
}

const onSearch = () => {
  console.log('search', formData.value)
  emit('search', formData.value)
}

const onReset = () => {
  formData.value.search = ''
  formData.value.city = '全国'
  console.log(areaPicker.value.reset())
  emit('reset')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElForm), {
      model: formData.value,
      rules: rulesForm.value,
      inline: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElFormItem), {
          label: " ",
          class: "address-item"
        }, {
          default: _withCtx(() => [
            _createVNode(AreaPicker, {
              onConfirm: onPositionConfirm,
              ref_key: "areaPicker",
              ref: areaPicker
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), {
          prop: "search",
          label: " "
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElInput), {
              class: "input",
              modelValue: formData.value.search,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.search) = $event)),
              placeholder: "请输入职位名称进行搜索",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_unref(ElFormItem), { label: " " }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElButton), {
              type: "primary",
              class: "btn search-btn",
              onClick: onSearch
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("搜索")
              ])),
              _: 1
            }),
            _createVNode(_unref(ElButton), {
              class: "btn reset-btn",
              onClick: onReset
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("重置")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})